import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PILLARS } from "../lib/data";

export const Pillars = () => {
  return (
    <section
      id="programs"
      data-testid="pillars-section"
      className="relative bg-[#0a0a0a] border-t border-neutral-900 py-24 md:py-40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24">
          <div>
            <div className="text-[10px] uppercase tracking-[0.4em] text-neutral-500 mb-6">
              — Programs
            </div>
            <h2
              data-testid="pillars-title"
              className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-white max-w-3xl"
            >
              Three pillars.
              <br />
              <span className="aa-outline-text">One mission.</span>
            </h2>
          </div>
          <p className="text-neutral-400 text-base md:text-lg max-w-sm font-light leading-relaxed">
            Each pillar is built to move communities forward — on the court, in
            the classroom, across continents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border border-neutral-900">
          {PILLARS.map((p, idx) => (
            <motion.article
              key={p.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.12, duration: 0.7 }}
              data-testid={`pillar-${p.num}`}
              className={`group relative bg-[#0a0a0a] p-8 md:p-10 border-neutral-900 ${
                idx > 0 ? "md:border-l border-t md:border-t-0" : ""
              } hover:bg-black transition-colors`}
            >
              <div className="aspect-[4/3] overflow-hidden border border-neutral-900 mb-8">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover grayscale group-hover:scale-105 transition-transform duration-700"
                />
              </div>

              <div className="flex items-start justify-between gap-4">
                <div className="font-display text-5xl text-neutral-700 group-hover:text-white transition-colors">
                  {p.num}
                </div>
                <ArrowUpRight
                  className="text-neutral-700 group-hover:text-white transition-colors"
                  size={28}
                />
              </div>

              <h3 className="font-display uppercase text-3xl md:text-4xl text-white mt-6">
                {p.title}
              </h3>
              <p className="text-neutral-400 text-sm md:text-base font-light leading-relaxed mt-4">
                {p.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
